/* Big Honey — Badlands theme (minimal JS) */
(function () {
  'use strict';

  // Qty stepper
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(1, current + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant swatch selection (visual only on static; real picker is in form below)
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-option-chip]');
    if (!chip) return;
    var group = chip.closest('[data-option-group]');
    if (!group) return;
    group.querySelectorAll('[data-option-chip]').forEach(function (c) {
      c.classList.remove('option__chip--active');
    });
    chip.classList.add('option__chip--active');
  });

  // Product gallery — thumbnail click swaps active slide
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-id]');
    if (!thumb) return;
    var id = thumb.getAttribute('data-thumb-id');
    var thumbsWrap = thumb.closest('[data-product-thumbs]');
    var galleryWrap = thumbsWrap && thumbsWrap.previousElementSibling && thumbsWrap.previousElementSibling.matches('[data-product-gallery]')
      ? thumbsWrap.previousElementSibling
      : document.querySelector('[data-product-gallery]');
    if (!galleryWrap) return;
    galleryWrap.querySelectorAll('.product__slide').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-slide-id') === id);
    });
    thumbsWrap.querySelectorAll('.product__thumb').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb-id') === id);
    });
  });

  // Keyboard arrow nav within thumbnails
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var active = document.activeElement;
    if (!active || !active.matches('[data-thumb-id]')) return;
    e.preventDefault();
    var thumbs = Array.from(active.parentElement.querySelectorAll('[data-thumb-id]'));
    var idx = thumbs.indexOf(active);
    var next = e.key === 'ArrowRight'
      ? thumbs[(idx + 1) % thumbs.length]
      : thumbs[(idx - 1 + thumbs.length) % thumbs.length];
    next.focus();
    next.click();
  });

  // Tiny reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
})();
